import React from "react";
import { Reveal } from "../lib/anim";
import { SERVICES, PRESTATIONS } from "../data/content";
import { Check } from "lucide-react";

const Services = () => (
  <section id="services" data-testid="services-section" className="py-24 lg:py-40 border-t border-white/10">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-16">
        <div>
          <Reveal><p className="eyebrow mb-6">Services</p></Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-[#F5F5F0] max-w-2xl">
              Ce que nous créons <span className="italic gold-text">pour vous</span>.
            </h2>
          </Reveal>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-px bg-white/10 border border-white/10">
        {SERVICES.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.08}>
            <div
              data-testid={`service-card-${i}`}
              data-cursor-hover
              className="group bg-[#050505] p-10 lg:p-14 h-full hover:bg-[#0d0d0d] transition-colors duration-500"
            >
              <span className="font-serif text-3xl text-[#D4AF37]/40 group-hover:text-[#D4AF37] transition-colors duration-500">
                {s.n}
              </span>
              <h3 className="font-serif text-3xl lg:text-4xl text-[#F5F5F0] mt-6 mb-4">{s.title}</h3>
              <p className="text-[#A1A1AA] leading-relaxed">{s.text}</p>
            </div>
          </Reveal>
        ))}
      </div>

      {/* Nos prestations */}
      <div id="prestations" className="mt-24 lg:mt-32 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <Reveal><p className="eyebrow mb-6">Nos prestations</p></Reveal>
          <Reveal delay={0.1}>
            <h3 className="font-serif font-light text-3xl lg:text-5xl text-[#F5F5F0] leading-tight">
              Un savoir-faire <span className="italic gold-text">complet</span>.
            </h3>
          </Reveal>
        </div>
        <div className="lg:col-span-8 grid sm:grid-cols-2 gap-x-10 gap-y-5">
          {PRESTATIONS.map((p, i) => (
            <Reveal key={p} delay={i * 0.05}>
              <div data-testid={`prestation-${i}`} className="flex items-center gap-4 py-4 border-b border-white/10">
                <span className="grid place-items-center w-6 h-6 rounded-full border border-[#D4AF37]/50 text-[#D4AF37] shrink-0">
                  <Check size={13} />
                </span>
                <span className="text-[#F5F5F0] text-lg">{p}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Services;
